/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import profile from "assets/images/profile.png";
import DataTable from "examples/Tables/DataTable";
import { CircularProgress, Icon, Switch } from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { getAllContacts } from "api";
import debounce from "lodash.debounce";
import { updateContact } from "api";

export default function data({ company, isMyProfile = true }) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    onSearchData("");
  }, []);

  const getAllContactsApi = useRef(
    debounce((search) => {
      var params = {
        page: 1,
        limit: 1000,
        companyId: company?._id,
        name: search,
      };
      setLoading(true);
      getAllContacts({
        params: params,
      })
        .then((responseJson) => {
          setList(responseJson?.contacts);
        })
        .catch((e) => {})
        .finally(() => {
          setLoading(false);
        });
    }, 500)
  ).current;

  const onSearchData = (val) => {
    getAllContactsApi(val);
  };

  const Contact = ({ name, detail, startDate, endDate, image }) => {
    const imgWidth = image ? "100%" : "50%";
    const imgHeight = image ? "100%" : "50%";
    const imgResize = image ? "cover" : "contain";

    return (
      <MDBox display="flex" gap={2}>
        <MDAvatar
          src={image || profile}
          size="sm"
          sx={{
            width: "45px", // optional: control size
            height: "45px", // optional: control size
            border: "2px solid",
            borderColor: "success.main",
            "& img": {
              width: imgWidth,
              height: imgHeight,
              objectFit: imgResize,
              objectPosition: "center",
            },
          }}
        />
        <MDBox>
          <MDTypography
            display="block"
            variant="button"
            fontWeight="medium"
            noWrap
            sx={{
              maxWidth: "300px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {name}
          </MDTypography>

          <MDTypography variant="caption">{detail}</MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  const columns = () => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "contact details", accessor: "contact", align: "center" },
      { Header: "created on", accessor: "created", align: "center" },
      {
        Header: "status",
        accessor: "status",
        align: "center",
      },
    ];
  };

  const rows = () => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <Contact
            name={`${item?.firstName || ""} ${item?.lastName || ""}`}
            detail={item?.designation}
            image={item?.profileURL}
          />
        ),
        contact: (
          <MDBox sx={{ px: 1, textAlign: "left" }}>
            <MDTypography display="block" variant="caption">
              {`${item?.contacts?.code} ${item?.contacts?.phone}`}
            </MDTypography>
            <MDTypography variant="caption">{item?.email}</MDTypography>
          </MDBox>
        ),
        created: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography variant="caption" noWrap>{`${moment(item?.createdAt).format(
              "DD MMM YYYY"
            )}`}</MDTypography>
          </MDBox>
        ),
        status: (
          <MDBox sx={{ px: 1 }}>
            {loadingId === item?._id ? (
              <CircularProgress size={24} color="success" />
            ) : (
              <Switch
                checked={item?.isActive}
                onChange={() => handleStatus(item)}
                color="success"
              />
            )}
          </MDBox>
        ),
      })
    );

    return rowsData;
  };

  const handleStatus = (item) => {
    setLoadingId(item?._id);
    var params = {
      isActive: item?.isActive ? false : true,
    };
    updateContactApi(params, item._id);

    // const updatedUsers = list.map((u) => (u._id === user.id ? { ...u, isActive: !u.isActive } : u));
    // setList(updatedUsers);
  };

  const updateContactApi = (params, id) => {
    updateContact({
      params: params,
      id: id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            getAllContactsApi("");
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoadingId(null);
      });
  };

  return (
    <MDBox>
      <DataTable
        table={{ columns: columns(), rows: rows() }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={true}
        canSearch={true}
        noEndBorder
        onSearch={(val) => {
          onSearchData(val);
        }}
      />
      {loading && (
        <MDBox display="flex" justifyContent="center" mt={2}>
          <CircularProgress size={24} color="success" />
        </MDBox>
      )}
    </MDBox>
  );
}
